import { Component } from '@angular/core';
import { Platform, MenuController, NavController, NavParams } from 'ionic-angular';
import { Keyboard } from '@ionic-native/keyboard/ngx';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';

import { AuthService } from '../../app/shared/services/auth.service';
import { qrCodeService } from '../../app/shared/services/qrCode.service';
import { LastScansService } from '../../app/shared/services/lastScans.service';

import { HomepageComponent } from '../home/home';
import { MotDePasseOublieComponent } from '../mot-de-passe-oublie/mot-de-passe-oublie';
import { RapportComponent } from '../rapport/rapport';
import { ElementVerifieComponent } from '../element-verifie/element-verifie';

@Component({
  selector: 'page-connexion',
  templateUrl: 'connexion.html'
})
export class ConnexionComponent {
    private auth: any = {
        _profil: false,
        _authenticationMode: 'client',
        _username: '',
        _password: '',
        _souvenir: true
    };
    isApp: boolean = true;
    loader: boolean = false;
    identifiantError: boolean = false;
    showFooter: boolean = true;
    qrCode: string = '';
    
    constructor( 
        private platform: Platform,
        private keyboard: Keyboard,
        private ga: GoogleAnalytics,
        private navCtrl: NavController,
        private menuCtrl: MenuController,
        private navParams: NavParams,
        private authService: AuthService,
        private qrCodeService: qrCodeService,
        private lastScansService: LastScansService
    ) {
        this.platform.ready().then(_ => {
            this.ga.trackView('Connexion');
            this.isApp = (this.platform.is('mobileweb')) ? false : true;
        });
        this.keyboard.onKeyboardShow().subscribe(_ => {
            this.showFooter = false;
        });
        this.keyboard.onKeyboardHide().subscribe(_ => {
            this.showFooter = true;
        });
        
        this.qrCode = this.navParams.get('qrCode');
    }

    login(): any {
        this.loader = true;
        this.auth._authenticationMode = (this.auth._profil) ? 'collaborateur' : 'client';
        this.authService.login(this.auth).subscribe(
            async (newToken: any) => {
                await this.authService.setToken(this.auth._username, newToken.access_token, this.auth._authenticationMode);
                this.keyboard.hide();
                // Pour garder sa connexion ouverte
                if (this.auth._souvenir) {
                    await this.authService.setRefreshToken(newToken.refresh_token);
                    await this.lastScansService.emitListeScans();
                    this.menuCtrl.enable(false, 'unauthenticated');
                    this.menuCtrl.enable(true, 'authenticated');
                    // Si le QR Code n'existe pas
                    if(this.qrCode === undefined) {
                        this.navCtrl.setRoot(HomepageComponent);
                    } else {
                        this.qrCodeService.getScanQRCode(this.qrCode).subscribe(
                            async (scan: any) => {
                                await this.lastScansService.setLastScans(this.auth._username, scan);
                                if (scan.qrCodeType == 'Installation') {
                                    this.navCtrl.setRoot(RapportComponent);
                                } else {
                                    this.navCtrl.setRoot(ElementVerifieComponent);
                                }
                            },
                            (error: any) => {
                                console.error(error);
                                this.navCtrl.setRoot(HomepageComponent);
                            }
                        );
                    }
                } else {
                    await this.lastScansService.emitListeScans();
                    this.menuCtrl.enable(false, 'unauthenticated');
                    this.menuCtrl.enable(true, 'authenticated');   
                    if (this.qrCode == undefined) {
                        this.navCtrl.setRoot(HomepageComponent);
                    } else {
                        this.qrCodeService.getScanQRCode(this.qrCode).subscribe(
                            async (scan: any) => {
                                await this.lastScansService.setLastScans(this.auth._username, scan);
                                if (scan.qrCodeType === 'Installation') {
                                    this.navCtrl.setRoot(RapportComponent);
                                } else {
                                    this.navCtrl.setRoot(ElementVerifieComponent);
                                }
                            },
                            (error: any) => {
                                console.error(error);
                                this.navCtrl.setRoot(HomepageComponent);
                            }
                        );
                    }
                }
            },
            (error: any) => {
                console.error(error);
                this.loader = false;
                this.keyboard.hide();
            }
        );
    }

    mdpOublie(): any {
        this.navCtrl.push(MotDePasseOublieComponent);
    }

    checkFocus(): any {
        if (!this.isApp) {
            this.showFooter = false;
        }
    }

    checkBlur(): any {
        if (!this.isApp) {
            this.showFooter = true;
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/connexion/connexion.ts